/**
 * Coverts the given value into an array
 * 
 * @param {*} value 
 * @returns {Array}
 */
const formatValueForValidation = (value) => {
    return Object.values(
        Array.isArray(value)
            ? value
            : [value]
    )
}

/**
 * Rule to check if the field is one of a given set of values
 * 
 * Usage: contains:value_1,value_2
 * 
 */
export default {
    name     : 'contains',
    validate : (value, data, parameters) => {
        //we should make sure the value is an array
        value = formatValueForValidation(value)

        //Using indexOf is a strict comparison
        return value.some(
            //As both value and parameters are an array we must have any value where its visible in any of the parameter values
            innerValue => parameters.some(
                parameter => innerValue == parameter
            )
        )
    },
    message: (field, data, parameters) => `The field ${field} must contain one of ${parameters.join(', ')}`
}